export const MISSION_NODE_WIDTH = 280;
export const MISSION_NODE_MIN_HEIGHT = 180;
export const QUEST_ITEM_HEIGHT = 40;
export const START_NODE_WIDTH = 80;
export const START_NODE_HEIGHT = 36;
export const NODE_HORIZONTAL_SPACING = 200;
export const NODE_VERTICAL_SPACING = 80;
export const SIDE_PANEL_WIDTH = 480;
export const POSITIONS_STORAGE_KEY_PREFIX = 'flow-positions';

// Quest node dimensions (when mission is expanded)
export const QUEST_NODE_WIDTH = 200;
export const QUEST_NODE_HEIGHT = 44;
export const EXPANDED_MISSION_PADDING = 24;
export const EXPANDED_MISSION_HEADER_HEIGHT = 56;
export const QUEST_NODE_GAP_X = 120;
export const QUEST_NODE_GAP_Y = 60;

// Quest node layout around mission nodes
export const QUESTS_PER_MISSION_ROW = 1;
export const MISSION_TO_QUEST_VERTICAL_GAP = 40;
export const MISSION_QUEST_GAP_X = 24;
export const MISSION_QUEST_GAP_Y = 24;
